import { BuilderComponent } from "@builder.io/react";
import {
  GetContentOptions,
  UserAttributes,
} from "@builder.io/sdk/dist/src/builder.class";
import { initializeBuilder } from "@faire/web--source/builder/BuilderComponents/initializeBuilder";
import { useBuilderContentQuery } from "@faire/web--source/builder/BuilderComponents/useBuilderContentQuery";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React, { PropsWithChildren, Suspense, useEffect } from "react";

import { getBuilderAPIKey } from "./builderUtils";

interface IProps extends PropsWithChildren {
  modelName: string;
  onViewEvent?: () => void;
  data?: object;
  targets?: UserAttributes;
  contentOptions?: GetContentOptions;
  fullWidth?: boolean;
}

const LazyRenderWithBuilder: React.FC<IProps> = ({
  modelName,
  onViewEvent,
  data,
  targets,
  contentOptions,
  fullWidth,
}) => {
  const apiKey = getBuilderAPIKey();

  useEffect(() => {
    initializeBuilder(apiKey);
  }, [apiKey]);

  const { data: sectionContent, isPending } = useBuilderContentQuery(
    modelName,
    {
      userAttributes: targets,
      ...contentOptions,
    }
  );
  const ref = useDoActionWhenVisible(onViewEvent);

  if (isPending) {
    return <LoadingSkeleton aspectRatio="16/9" width="100%" />;
  }
  return (
    <div ref={ref} style={fullWidth ? { width: "100%" } : undefined}>
      <BuilderComponent
        content={sectionContent}
        model={modelName}
        data={data}
      />
    </div>
  );
};

export const RenderWithBuilder: React.FC<IProps> = (props) => {
  return (
    <Suspense fallback={null}>
      {/* carousel and other widets are lazy loaded, so we need suspense  */}
      <LazyRenderWithBuilder {...props} />
    </Suspense>
  );
};
